<template>
  <router-view />
</template>

<script>

export default {
  name: 'Orders',
};
</script>
